import { render, staticRenderFns } from "./HppAdjPrintDetails_Items.vue?vue&type=template&id=163cb37d&"
import script from "./HppAdjPrintDetails_Items.vue?vue&type=script&lang=js&"
export * from "./HppAdjPrintDetails_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports